import { useAutoApplyResumeDistributionModal } from './useAutoApplyResumeDistributionModal'
import { SupportedUserAutoApplyResumeDistributionModal } from './SupportedUserAutoApplyResumeDistributionModal'

export const AutoApplyResumeDistributionModal = () => {
  const { isOpen, closeModal } = useAutoApplyResumeDistributionModal()

  if (!isOpen) return null

  return <SupportedUserAutoApplyResumeDistributionModal closeModal={closeModal} />
}
